import React, { useState } from 'react';
import {Stepper, Step, StepLabel, Box} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CreateEventForm from "./CreateEventForm" ;
import CreateTicketsForm from "./CreateTicketsForm";
import { FaTicketAlt, FaMapMarkerAlt, FaCalendarAlt , FaArrowRight} from "react-icons/fa";
import { API_URL_BASE } from './config';



const steps = ['Create Event', 'Setup Tickets', 'Done'];

const EventCreationStep = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [eventId, setEventId] = useState(null);
  const [eventType, setEventType] = useState(null);
  const [savedFormData, setSavedFormData] = useState(null);
  const [savedTickets, setSavedTickets] = useState([]);
  const [ticketShowForm, setTicketShowForm] = useState(false);
  const navigate = useNavigate();	

  const handleNext = () => setActiveStep((prev) => prev + 1);
  const handleReset = () => {
    //setActiveStep(0);
    //setEventId(null);
	navigate("/dashboard/events");
  };
  
  const handleCopyLink = () => {
	navigator.clipboard.writeText(`${API_URL_BASE}/buy/${eventId}`)
	  .then(() => {
	    alert('Copied to clipboard!');
	  })
	  .catch((err) => {
	    console.error('Failed to copy:', err);
	  });
	
  }
  

  return (
    <Box sx={{ width: '100%', maxWidth: { xs: '100%', sm: 800 } , mx: 'auto' }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <Box sx={{ mt: 2 }}>
        {activeStep === 0 && (
          <CreateEventForm
		      initialData={savedFormData}
		      onFormChange={setSavedFormData}
			  existingEventId={eventId}
              onSuccess={(newEventId, newEventType) => {
				// If event type changed, clear previously added tickets (they belong to old type)
				if (newEventType !== eventType) {
				  setSavedTickets([]);
				  setTicketShowForm(false);
				}
              setEventId(newEventId);
			  setEventType(newEventType);
              handleNext();
            }}
          />
        )}

        {activeStep === 1 && (
          <CreateTicketsForm
            eventId={eventId}
			eventType={eventType}
			eventData={savedFormData}
            onSuccess={handleNext}
			onBack={() => setActiveStep((prev) => prev - 1)}
			addedTickets={savedTickets}
			onTicketsChange={setSavedTickets}
			showForm={ticketShowForm}
			onShowFormChange={setTicketShowForm}
          />
        )}

        {activeStep === 2 && (
			<div className="event-done-card">
			   <h2 className="event-done-title">Event Created Successfully !!</h2>
              <p className="event-done-subtitle">Publish the event from your dashboard to make ticket sales go live.</p>

			   {/* Event summary */}
			   {savedFormData && (
			     <div className="event-done-summary">
			       {savedFormData.eventImage && (
			         <img
			           src={`data:image/png;base64,${savedFormData.eventImage}`}
			           alt={savedFormData.eventName}
			           className="event-done-img"
			         />
			       )}
			       <div className="event-done-details">
			         <h3>{savedFormData.eventName}</h3>
			         {savedFormData.address && <p> <FaMapMarkerAlt style={{paddingRight: '10px'}} />{savedFormData.address}</p>}
			         {savedFormData.eventStartDate && (
			           <p>
					    <FaCalendarAlt style={{paddingRight: '10px'}}/>
			              {new Date(savedFormData.eventStartDate).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })}
			             {<FaArrowRight style={{paddingRight: '10px', paddingLeft: '10px'}}/>}
			             {savedFormData.eventEndDate
			               ? new Date(savedFormData.eventEndDate).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })
			               : ''}
			           </p>
			         )}
			         <span className="event-saved-type">{savedFormData.eventDesc}</span>
			       </div>
			     </div>
			   )}

			   {/* Tickets summary */}
			   {savedTickets.length > 0 && (
			     <div className="event-done-tickets">
			       <h4>Tickets Created</h4>
			       {savedTickets.map((t, i) => (
			         <div key={i} className="added-ticket-row">
			           <span className="added-ticket-name"><FaTicketAlt style={{paddingRight: '10px'}}/> {t.name}</span>
			           {eventType !== 'FREE' && <span className="added-ticket-price">€ {parseFloat(t.price).toFixed(2)}</span>}
			           <span className="added-ticket-capacity">{t.capacity} tickets</span>
			         </div>
			       ))}
			     </div>
			   )}

			   {/* Actions */}
			   <div className="event-done-actions">
			     <button className="submit-btn" onClick={handleReset}>
			       Go to Events 
			     </button>
				</div>
			<p className="event-done-publish-hint">
			 Go to your event dashboard and click <strong>Publish Event</strong> to start selling tickets.
			</p>


			</div>
        )}
      </Box>
    </Box>
  );
};

export default EventCreationStep;
